import { combineReducers } from 'redux';

import data from './data';
import auth from './auth';
import admin from './admin';
import networks from './networks';
import users from './users';

export default combineReducers({
  data,
  auth,
  admin,
  networks,
  users,
});
